export default __webpack_public_path__ + "static/apple-app-c6bb5660420698456bba43ff614f64fa.svg";